import { render, staticRenderFns } from "./TablaDtoArticulo.vue?vue&type=template&id=6dd9c85b"
import script from "./TablaDtoArticulo.vue?vue&type=script&lang=js"
export * from "./TablaDtoArticulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports